import type { User } from '@mend/types/user';

/**
 * Some instances of this BaseUser could be simplified ones that would not have
 * any inclusivity fields. The concatenation is a fallback.
 */
interface BaseUser extends Pick<User, 'firstName' | 'lastName'> {
  displayFullName?: string;
  displayPronoun?: string | null;
}

export function getFullName<T extends BaseUser>(user: T): string {
  if (user.displayFullName) {
    return user.displayFullName;
  }

  return `${user.lastName}, ${user.firstName}`;
}

export function getFullNameWithPronouns<T extends BaseUser>(user: T): string {
  const fullName = getFullName(user);

  if (user.displayPronoun) {
    return `${fullName} (${user.displayPronoun})`;
  }

  return fullName;
}

export function hasPlaceholderEmail(email: User['email']): boolean {
  return email.endsWith('@example.com');
}
